export default __webpack_public_path__ + "static/media/work-from-home.e89ad9c3.png";